import * as z from 'zod';
import type { Assessment } from '../core/assess';

/** What the summary card shows. Built the same way for the sample and for live demos. */
export const SummaryViewSchema = z.object({
  level: z.enum(['ok', 'attention', 'urgent']),
  headline: z.string(),
  rows: z.array(z.tuple([z.string(), z.string()])),
  quote: z.string().nullable(),
});
export type SummaryView = z.infer<typeof SummaryViewSchema>;

const MOOD = { good: 'хорошее', neutral: 'ровное', low: 'подавленное' } as const;
const SLEEP = { ok: 'выспалась', poor: 'плохо спала' } as const;
const NOT_DISCUSSED = 'не обсуждали';

const yesNo = (value: boolean | null): string =>
  value === null ? NOT_DISCUSSED : value ? 'да' : 'нет';

export function toSummaryView(assessment: Assessment): SummaryView {
  if (!assessment.ok) {
    return {
      level: 'attention',
      headline: 'Не удалось разобрать разговор. Мы покажем его вам целиком.',
      rows: [],
      quote: null,
    };
  }
  const { extraction } = assessment;
  return {
    level: assessment.level,
    headline: extraction.summary_ru,
    rows: [
      ['Настроение', extraction.mood ? MOOD[extraction.mood] : NOT_DISCUSSED],
      ['Сон', extraction.sleep ? SLEEP[extraction.sleep] : NOT_DISCUSSED],
      ['Лекарства', yesNo(extraction.meds_taken)],
      ['Жалобы', extraction.complaints.map((c) => c.what).join(', ') || 'нет'],
      ['Планы', extraction.went_out_or_plans ?? NOT_DISCUSSED],
    ],
    quote: extraction.quote,
  };
}
